import { render, staticRenderFns } from "./AutoPaymentTemplate.vue?vue&type=template&id=4c2963c1&scoped=true"
import script from "./AutoPaymentTemplate.vue?vue&type=script&lang=ts"
export * from "./AutoPaymentTemplate.vue?vue&type=script&lang=ts"
import style0 from "./AutoPaymentTemplate.vue?vue&type=style&index=0&id=4c2963c1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2963c1",
  null
  
)

export default component.exports